import React, { FC } from "react";
import SubscribeForm from "./SubscribeForm";
import environment from "../../environment";
import { makeStyles } from "@material-ui/core/styles";
import { TheCycleverseTheme } from "src/theme";

const useStyles = makeStyles((theme: TheCycleverseTheme) => ({
  newsletterBlogSnippet: {
    marginBottom: theme.spacing(2),
  },
}));

const NewsletterBlogSnippet = (props) => {
  const classes = useStyles();
  return (
    <SubscribeForm
      afterSubscribe={() => {}}
      close={() => {}}
      mailchimpUrl={environment.mailchimpNewsletterUrl}
      page="blog-snippet"
      formVariant="compact"
      showPrivacyNote={true}
      className={classes.newsletterBlogSnippet}
    >
      {props.children}
    </SubscribeForm>
  );
};

export default NewsletterBlogSnippet;
